export default __webpack_public_path__ + "static/media/LA-2.cdfdd7c6.JPG";